'use client'
import { apiSubscribeNewsletter } from '@/apis/page_optimization';
import { faPaperPlane, FontAwesomeIcon } from '@/constants/icons';
import React, { useState } from 'react'
import { toast } from "react-toastify";

interface Props {
    companyId: string;
}

const FooterNewsletter = ({ companyId }: Props) => {
    const [email, setEmail] = useState<string>("");
    
    const validateEmail = (email: string) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };

    const handleRate = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!validateEmail(email)) {
            toast.error("Please enter a valid email address.");
            return;
        }
        await handleSubmit();
    };

    const handleSubmit = async () => {
        try {
            const response = await apiSubscribeNewsletter(companyId, email);
            if (response.message === "Subscribed successfully") {
                toast.success("Joined Successfully!", { autoClose: 2000 });
                setEmail("");
            } else {
                toast.error("Already a subscriber.");
            }
        } catch (error) {
            toast.error("Subscription failed.");
        }
    };

    return (
        <form className="w-full" onSubmit={handleRate} autoComplete="off">
            <div className="relative flex items-center group">
                <input 
                    type="email" 
                    placeholder="Drop your email here..." 
                    className="w-full bg-slate-900/50 border-2 border-slate-700 text-white text-sm rounded-2xl py-4 pl-6 pr-16 focus:outline-none focus:border-[#D61C4E] transition-all duration-300 placeholder:text-slate-600 font-bold" 
                    value={email} 
                    onChange={(e) => setEmail(e.target.value)} 
                />
                <button 
                    type="submit" 
                    className="absolute right-2 top-2 bottom-2 w-11 h-11 bg-[#D61C4E] hover:bg-white hover:text-[#D61C4E] text-white rounded-xl transition-all duration-500 flex items-center justify-center shadow-lg shadow-[#D61C4E]/20 active:scale-90"
                >
                    <FontAwesomeIcon icon={faPaperPlane} className="w-4 h-4" />
                </button>
            </div>
        </form>
    );
}

export default FooterNewsletter;